/**
 * What the analyst understood a question as, shown under its answer.
 *
 * A follow-up such as "now by region" is planned against the previous answer,
 * and a reader can only trust that if they can see what it was taken to mean.
 * The strip says so in one line and lists what changed, which is also what
 * makes a misreading obvious enough to correct with the next message.
 */
import { GitCompareArrows } from "lucide-react";
import type { AnswerContext } from "../../../services/answerContext";
import { describeChange, relationLabel } from "./answerContextView";

interface Props {
  context: AnswerContext;
}

export default function AnswerContextStrip({ context }: Props) {
  return (
    <aside className="answer-context" aria-label="How this question was understood">
      <p>
        <GitCompareArrows size={14} aria-hidden="true" />
        {context.relation !== "new" && (
          <span className="relation-badge">{relationLabel(context.relation)}</span>
        )}
        <span className="answer-context-reading">
          Understood as: {context.interpretation}
        </span>
      </p>
      {context.changes.length > 0 && (
        <ul aria-label="Changed from the previous answer">
          {context.changes.map((change) => (
            <li key={change.field}>{describeChange(change)}</li>
          ))}
        </ul>
      )}
    </aside>
  );
}
